import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import {
  createViolation, editViolation,
} from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import {
  getFirstFormError, getResponseError, setFormError,
} from '../../../utils/utils';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';

import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import ViolationDTO from '../../../dto/ViolationDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import { getAuthorizedData } from '../../Authorized/reducer';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadDriverLogListAll } from '../../DriverLog/actions';
import { loadVehicleRegistryList, loadVehicleRegistryStatusHistory } from '../../VehicleRegistry/actions';
import { loadApplicantListAll } from '../../Applicant/actions';
import { getLegalEntityName } from '../../../utils/formatters';
import { getViolationData } from '../reducer';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { VIOLATION_STATUS_LIST } from '../../../configs';
import TextInputWithSelect from '../../../components/fields/TextInput/TextInputWithSelect';

export default function ViolationForm(props) {
  const {
    onClose = () => {},
    loadData = () => {},
    isEdit = false,
  } = props;
  const dispatch = useDispatch();
  const { currentViolation } = useSelector(getViolationData);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const { authorizedData } = useSelector(getAuthorizedData);

  const {
    control,
    getValues,
    setValue,
    formState: { errors },
    setError,
    setFocus,
    watch,
  } = useForm({
    mode: 'onChange',
    defaultValues: isEdit ? currentViolation : {
      driver_id: null,
      resolution_creator_id: authorizedData?.id,
      status: '1', // нет ифнормации от Алексея каким должен быть статус
    },
  });

  const handleSave = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Сохранение нарушения', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    dispatch(isEdit ? editViolation({ id: currentViolation?.id, ...getValues() }) : createViolation(values))
      .then(() => {
        loadData();
        onClose();
        successNotification('Сохранение нарушения', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение нарушения', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const DTO = new ViolationDTO();
  const attributes = DTO.getAttributesByName();

  useEffect(() => {
    const subscription = watch(values => {
      setSelectedDriver(values?.driver_id || null);
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  return (
    <Dialog
      className="violation-page-form"
      onClose={onClose}
      open
    >
      <DialogTitle header={isEdit ? 'Редактирование нарушения' : 'Создание нарушения'} title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="violation-page-form-content">
        <Row className="row-cols-1">
          <FieldDTO
            control={control}
            component={CustomSelectInputWithHelper}
            dtoObject={attributes.applicant_id}
            portalClassName="executor-selector"
            loadAction={loadApplicantListAll}
            optionFormatter={item => ({ value: item.id, name: getLegalEntityName(item) })}
            variant="material"
            additionalFilter={{ in_registry_carrier: true }}
            prefix="applicant"
            type="text"
            withLabel
            filterName="search"
            usePortal
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={TextInputWithSelect}
            dtoObject={attributes.driver_full_name}
            portalClassName="executor-selector"
            loadAction={loadDriverLogListAll}
            optionFormatter={item => ({ value: item.id, name: item.full_name })}
            variant="material"
            type="text"
            withLabel
            filterName="search"
            usePortal
            withSearch
            inputAfter={
              <Icons customIcon icon={selectedDriver ? 'success' : 'suspended'} className="me-2" />
          }
            onSelect={i => {
              setValue('driver_id', i?.value || null);
            }}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInputWithHelper}
            dtoObject={attributes.vehicle_id}
            portalClassName="executor-selector"
            filterName="vehicle_lpn"
            loadAction={loadVehicleRegistryList}
            isLazyLoad
            optionFormatter={item => ({ value: item.id, name: item.vehicle_lpn })}
            variant="material"
            type="text"
            withLabel
            usePortal
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.koap}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.type}
            options={[{ value: 'applicant', name: 'Перевозчик' }, { value: 'driver', name: 'Водитель' }]}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            options={VIOLATION_STATUS_LIST}
            withLabel
            variant="material"
            placeholder=""
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.resolution_at}
            variant="material"
            withLabel
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.resolution_number}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.uin}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
          />
        </Row>
        {/* <Row className="row-cols-1"> */}
        {/*  <FieldDTOWithCol */}
        {/*    control={control} */}
        {/*    component={TextInputWithLabel} */}
        {/*    dtoObject={attributes.resolution_creator_id} */}
        {/*    variant="material" */}
        {/*    inputClassName="custom-scroll-theme" */}
        {/*    withLabel */}
        {/*    disabled */}
        {/*  /> */}
        {/* </Row> */}
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.sum}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.driver_document}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={onClose}>Отменить</Button>
          <Button className="hff-clear-show" type="submit" onClick={handleSave}>Сохранить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
